import React, { useState } from 'react'
import { FaInstagram } from 'react-icons/fa';
import { HiXMark } from 'react-icons/hi2';
import { ImFacebook } from 'react-icons/im';
import { MdArrowOutward } from 'react-icons/md';
import { PiPhoneCallFill } from 'react-icons/pi';
import { RiMenu3Fill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/logo.png';

const Header = () => {
    const [showNav, setShowNav] = useState(false);
    const navigate = useNavigate();

  return (
    <>
    <section className='py-2 border-bottom'>
        <div className='container'>

<div className='d-md-flex d-sm-flex text-center d-block text-muted justify-content-between'>
<p className='my-0 me-2'>Welcome To our Trade Journal Platform</p>
<p className='my-0'>Track &nbsp;|&nbsp; Analysis &nbsp;|&nbsp; Management &nbsp;|&nbsp; Help Line <PiPhoneCallFill size={18} className='text-primary' /> 8018532612</p>
</div>
{/* flex ends */}

        </div>
    </section>


<section className='sticky-top bg-white'>
    <div className='container d-flex justify-content-between align-content-center'>

<div>
        <img src={Logo} className='img-fluid my-2' style={{height: '3.8em'}} />
<span className='fm-inter fw-bold fs-5 my-4'>Trade <span className='fw-bolder'>Intell</span></span></div>
{/* <p className='fm-inter fw-bold fs-3 my-3'>Trade <span className='fw-bolder'>Intell</span></p> */}

<div className='d-md-flex d-none m-0 my-3'>
    <p className='header-text my-2' onClick={() => navigate('/')}>Home</p>
    <p className='header-text my-2' onClick={() => navigate('/about')}>About Us</p>
    <p className='header-text my-2' onClick={() => navigate('/privacy-policy')}>Privacy Policy</p>
    <p className='header-text my-2' onClick={() => navigate('/contact')}>Contact</p>
    <button className='header-btn animate__animated animate__pulse animate__infinite'>Try Now <MdArrowOutward size={20} /></button>
</div>

<div className='d-md-none d-flex m-0 my-3'>
    <RiMenu3Fill className='nav-btn me-2' onClick={() => setShowNav(true)} size={36} />
    {/* <button className='header-btn px-2'>Download App <MdArrowOutward size={20} /></button> */}
</div>

    </div>
</section>

{showNav && (
    <>
<div className='nav-area animate__animated animate__fadeInRight p-4'>

    <div className='d-flex justify-content-between my-2'>

<div>
        <img src={Logo} className='img-fluid' style={{height: '5.4em'}} />
    <p className='fm-inter fw-bold my-0'>Trade <span className='fw-bolder'>Intell</span></p>
    </div>
    <HiXMark size={32} onClick={() => setShowNav(false)} />
</div>

<hr />

<p className='nav-area-btn' onClick={() => {setShowNav(false); navigate('/') }}>Home</p>
<p className='nav-area-btn' onClick={() => {setShowNav(false); navigate('/about') }}>About Us</p>
<p className='nav-area-btn' onClick={() => {setShowNav(false); navigate('/privacy-policy') }}>Privacy Policy</p>
<p className='nav-area-btn' onClick={() => {setShowNav(false); navigate('/contact') }}>Contact</p>

    <button className='header-btn px-2 mt-3'>Download App <MdArrowOutward size={20} /></button>

<p className='fm-inter fw-bold fs-5 mt-4'>Follow Us</p>

<ImFacebook className='nav-area-icon me-2' size={36} />
<FaInstagram className='nav-area-icon' size={36} />


</div>
    </>
)}

    </>
  )
}

export default Header